import type { TaxonomyKind } from "@recipevault/shared";

export const KIND_LABEL: Record<TaxonomyKind, string> = {
  tag: "Tags",
  category: "Categories",
  cuisine: "Cuisines",
  diet: "Diet flags",
};

export const KIND_LABEL_SINGULAR: Record<TaxonomyKind, string> = {
  tag: "tag",
  category: "category",
  cuisine: "cuisine",
  diet: "diet flag",
};

export const KIND_ORDER: ReadonlyArray<TaxonomyKind> = ["tag", "category", "cuisine", "diet"];
